/**
 * Employee-code display helper.
 *
 * Workers still in the joining pipeline carry a temporary placeholder
 * emp_code of the form `DRAFT-<hex>` (assigned at draft creation). The real
 * running code `E-YYYY-NNNN` is minted only when HR generates the employee
 * code during joining. That placeholder is an internal value — it should
 * never be shown to users as if it were a real code.
 *
 * Use `displayEmpCode` anywhere an employee's code is rendered for a human.
 */

const DRAFT_PREFIX = "DRAFT-";

/** True when the code is a temporary joining placeholder, not a real code. */
export function isDraftEmpCode(code?: string | null): boolean {
  return !!code && code.toUpperCase().startsWith(DRAFT_PREFIX);
}

/**
 * Human-facing employee code. Returns a friendly "code pending" label for
 * un-activated joiners; otherwise the real code (or an em dash when blank).
 */
export function displayEmpCode(
  code?: string | null,
  pendingLabel = "Draft — code pending",
): string {
  if (!code) return "—";
  if (isDraftEmpCode(code)) return pendingLabel;
  return code;
}
